import { render, staticRenderFns } from "./ActivateAccount.vue?vue&type=template&id=1f970cee&scoped=true"
import script from "./ActivateAccount.vue?vue&type=script&lang=js"
export * from "./ActivateAccount.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=1f970cee&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f970cee",
  null
  
)

export default component.exports